import { create } from "zustand";

export const useLegaladviser = create((set) => ({
  userId: "",
  setUserId: (userId) => set({ userId: userId }),
}));

